<template>
            
           
   
         
         
  <d-form @submit.prevent="submit" class="order-form d-flex flex-column flex-lg-row row">
    <d-col class="col-12 col-lg-6">
      <d-card class="mb-3">
        <d-card-body>
          <h3 class="card-title mb-3">
            {{ $t('order.detail.personal_information') }}
          </h3>

          <d-row>
            <d-col cols="6">
              <form-group v-model="d_data.customer.first_name" :label="$t('input.label.first_name')" :placeholder="$t('input.placeholder.first_name')" :readonly="!editMode" />
            </d-col>

            <d-col cols="6">
              <form-group v-model="d_data.customer.last_name" :label="$t('input.label.last_name')" :placeholder="$t('input.placeholder.last_name')" :readonly="!editMode" />
            </d-col>

            <d-col cols="12">
              <form-group v-model="d_data.customer.email" :label="$t('input.label.email')" :placeholder="$t('input.placeholder.email')" :readonly="!editMode" type="email" />
            </d-col>

            <d-col cols="12">
              <form-group v-model="d_data.customer.phone" :label="$t('input.label.phone_number')" :placeholder="$t('input.placeholder.phone_number')" :readonly="!editMode" type="tel" />
            </d-col>
          </d-row>
        </d-card-body>
      </d-card>

      <d-card>
        <d-card-body>
          <h3 class="card-title mb-3">
            {{ $t('order.detail.vehicle_information') }}
          </h3>

          <d-row>
            <d-col cols="6">
              <form-group v-model="d_data.journey.car.model" :label="$t('input.label.car_model')" :placeholder="'N/A'" :readonly="!editMode" />
            </d-col>

            <d-col cols="6">
              <form-group v-model="d_data.journey.car.color" :label="$t('input.label.car_color')" :placeholder="'N/A'" :readonly="!editMode" />
            </d-col>

            <d-col cols="6">
              <form-group v-model="d_data.journey.car.license_plate" :label="$t('input.label.license_plate')" :placeholder="$t('input.placeholder.license_plate')" :readonly="!editMode" />
            </d-col>

            <d-col cols="6">
              <form-group v-model="d_data.journey.travellers" :label="$t('input.label.travelers')" :placeholder="$t('input.placeholder.travelers')" :readonly="!editMode" type="number" />
            </d-col>
          </d-row>
        </d-card-body>
      </d-card>
    </d-col>

    <d-col class="col-12 col-lg-6 mt-3 mb-0 my-lg-0">
      <d-card class="mb-3">
        <d-card-body>
          <h3 class="card-title mb-3">
            {{ $t('order.detail.flight_information') }}
          </h3>

          <d-row>
          
            <d-col cols="6">
              <form-group v-model="d_data.journey.departure_flight_number" :label="$t('input.label.departure_flight_number')" :placeholder="'N/A'" :readonly="!editMode" />
            </d-col>

            <d-col cols="6">
              <form-group v-model="d_data.journey.arrival_flight_number" :label="$t('input.label.arrival_flight_number')" :placeholder="'N/A'" :readonly="!editMode" />
            </d-col>
          </d-row>

          <date-form-group v-model="d_data" :editMode="editMode" />
        </d-card-body>
      </d-card>

      <d-card v-if="editMode && c_paymentNeeded">
        <d-card-body>
          <h3 class="card-title mb-3">
            {{ $t('order.detail.payment') }}
          </h3>

          <d-row>
            <d-col cols="12">
              {{ $t('order.edit.additional_costs')}}
            </d-col>
            <d-col cols="12" class="mt-3">
              <r-button v-if="c_paymentNeeded" @click="payment" theme="success">
                  {{ $t('button.pay_and_save_changes') }}
              </r-button>
            </d-col>
          </d-row>
        </d-card-body>
      </d-card>
    </d-col>

    <d-col v-if="editMode" class="col-12 my-3 col-lg-6">
      <d-row>
        <d-col cols="12">
          {{ $t('order.edit.asterisk_fields') }}
        </d-col>

        <d-col v-if="d_priceMutation.errors.has('message')" cols="6" class="text-danger">
          {{ d_priceMutation.errors.get('message') }}
        </d-col>
      </d-row>
    </d-col>

    <d-col v-if="editMode" cols="12">
      <d-row class="justify-content-between mt-3">
        <d-col class="align-self-center" cols="auto">
          <d-btn @click="$emit('hideForm', false)" theme="danger" type="button">
            {{ $t('button.cancel') }}
          </d-btn>
        </d-col>

        <d-col class="align-self-center" cols="auto">

          <r-button v-if="!c_paymentNeeded" :disabled="d_priceMutation.error" :error="d_mutation.error" :loading="d_loading" :success="d_mutation.success">
            {{ $t('button.save_changes') }}
          </r-button>

          <div v-if="d_mutation.errors['errors']">   
             <p class="text-danger">
               {{ d_mutation.errors["errors"][""] }}
             </p>
            
          </div>

        </d-col>
      </d-row>
    </d-col>
  </d-form>
</template>

<script>
import Helpers from '@/library/Helpers';
import Mutation from '@/library/Mutation';
import DateFormGroup from '@/components/order/DateFormGroup';

export default {
  name: 'order-form',
  components: { DateFormGroup },
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      d_data: this.order,
      d_mutation: new Mutation(),
      d_priceMutation: new Mutation(),
      d_originalOrderCopy: {},
      d_paidFields: [
        'from',
        'to',
      ],
      d_paidFieldsChanged: false,
      d_successURL: '',
      d_paymentURL: '',
      c_paymentNeeded: false,
      d_loading:false

    };
  },
  created () {
    const fullUrl = window.location;
    const appRootUrl = `${fullUrl.protocol}//${fullUrl.host}${process.env.BASE_URL}`;
    const pageUrl = `${appRootUrl}order/${this.d_data.id}/detail`;

    this.d_successURL = Helpers.buildUrl(pageUrl, { fromEdit: true });
  },

  methods: {
    payment() {
      if(this.d_paymentURL !=""){
        window.location.replace(this.d_paymentURL)
      }
      return
    },
    submit: async function () {
      if (!this.editMode) {
        return;
      }
        let  mutation = require('@/graphql/bookings/UpdateBooking.gql')
        
        // Add default variables for creating and updating
        let variables = {
          id: this.d_data.id,
          phone: this.d_data.customer.phone,
          email: this.d_data.customer.email,
          from: this.d_data.from,
          to: this.d_data.to,
          license_plate: this.d_data.journey.car.license_plate,
          departure_flight_number: this.d_data.journey.departure_flight_number,
          arrival_flight_number: this.d_data.journey.arrival_flight_number,
          model: this.d_data.journey.car.model,
          color: this.d_data.journey.car.color,
          first_name:this.d_data.customer.first_name,
          last_name:this.d_data.customer.last_name,
          travellers:parseInt(this.d_data.journey.travellers)
        };

        try {
          this.d_loading = true
          const data = await this.$apollo.mutate({mutation, variables, fetchPolicy: 'no-cache'})
            .then(data => {
              this.d_loading = false
              if (!data.data.updateBooking.success) {
                data.data.updateBooking.errors.forEach(err => {
                  console.log(err);
                });
              } else {
                if(data.data.updateBooking.booking.payment_url !=""){
                  this.c_paymentNeeded = true
                  this.d_paymentURL = data.data.updateBooking.booking.payment_url
                }else if(data.data.updateBooking.success){
                  this.d_data = data.data.updateBooking.booking
                  this.$emit('hideForm', true);
                }
              

              }
            })
        } catch (error) {
          console.log(error);
          // Todo: show feedback
       
        }
      },
  
    formatMutationData () {
      return {
        id: this.d_data.id,
        phone: this.d_data.customer.phone,
        email: this.d_data.customer.email,
        from: this.d_data.from,
        to: this.d_data.to,
        license_plate: this.d_data.journey.car.license_plate,
        departure_flight_number: this.d_data.journey.departure_flight_number,
        arrival_flight_number: this.d_data.journey.arrival_flight_number,
        model: this.d_data.journey.car.model,
        color: this.d_data.journey.car.color,
        first_name:this.d_data.customer.first_name,
        last_name:this.d_data.customer.last_name,
        travellers:parseInt(this.d_data.journey.travellers)
      };
    },
    getPriceUpdate () {
      this.d_priceMutation.reset();
      this.d_priceMutation.mutate(
        require('@/graphql/orders/GetUpdateOrderPrice.gql'), this.formatMutationData()
      );
    },
  },
  watch: {
    editMode () {
      if (this.editMode) {
        this.d_mutation.reset();
        this.d_priceMutation.reset();

        this.d_originalOrderCopy = Object.assign({}, this.d_data);
      } else {
        this.d_paidFieldsChanged = false;
      }
    },
    order () {
      this.d_data = this.order;
    },
    d_data: {
      handler () {
        if (!this.editMode) {
          return;
        }

        this.d_paidFieldsChanged = this.d_paidFields.some(field => {
          return this.d_data[field] !== this.d_originalOrderCopy[field];
        });

        if (this.d_paidFieldsChanged) {
          this.getPriceUpdate();
        }
      },
      deep: true
    },
  }
};
</script>
